import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../Wrapper';

const CardsWrapper = ({ type, ...props }) => <Wrapper {...props} className={`cards-wrapper ${type}-cards-wrapper`} />;

CardsWrapper.propTypes = {
  type: PropTypes.oneOf(['narrow', 'wide'])
};

export default CardsWrapper;
